import { ArrowLeft } from "lucide-react";

export default function PrivacyPage({ onBack }) {
  return (
    <div className="min-h-screen bg-[#F8FAFC] p-6" data-testid="privacy-page">
      <div className="max-w-2xl mx-auto">
        <button onClick={onBack} className="flex items-center gap-2 text-green-700 hover:text-green-800 text-sm font-semibold mb-6" data-testid="privacy-back">
          <ArrowLeft className="w-4 h-4" /> Torna indietro
        </button>
        <div className="bg-white border border-slate-200 rounded-2xl p-8 shadow-sm">
          <h1 className="text-2xl font-bold text-slate-800 mb-6">Privacy Policy</h1>
          <div className="prose prose-sm prose-slate max-w-none space-y-4 text-slate-600">
            <p><strong>Titolare del trattamento:</strong> AC Digital App</p>
            <p><strong>Sito:</strong> https://gestionepassword.it</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">1. Dati raccolti</h2>
            <p>Raccogliamo esclusivamente i dati necessari al funzionamento del servizio:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Indirizzo email per l'autenticazione</li>
              <li>Nome (facoltativo) per personalizzare l'esperienza</li>
              <li>Password dell'account archiviate tramite hash PBKDF2</li>
              <li>Voci del vault cifrate prima del salvataggio</li>
            </ul>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">2. Finalita' del trattamento</h2>
            <p>I dati vengono trattati esclusivamente per fornire il servizio di gestione password. Non vengono condivisi con terze parti, non vengono utilizzati per profilazione o marketing.</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">3. Sicurezza</h2>
            <p>Le voci del vault sono cifrate prima del salvataggio. L'accesso richiede autenticazione e la comunicazione tra app e backend avviene tramite HTTPS.</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">4. Conservazione</h2>
            <p>I dati vengono conservati per il tempo necessario alla fornitura del servizio. L'utente puo' richiedere la cancellazione del proprio account contattando l'amministratore.</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">5. Diritti dell'utente</h2>
            <p>Ai sensi del GDPR, l'utente ha diritto di accesso, rettifica, cancellazione e portabilita' dei propri dati. Per esercitare questi diritti, contattare: acdigital.app@gmail.com</p>
            <h2 className="text-lg font-semibold text-slate-800 mt-6">6. Cookie</h2>
            <p>Il sito utilizza esclusivamente cookie tecnici necessari al funzionamento (token di sessione). Non utilizziamo cookie di profilazione o tracciamento di terze parti.</p>
          </div>
        </div>
      </div>
    </div>
  );
}
